import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  selected?: boolean;
}
export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  onClick,
  selected = false
}) => {
  const baseStyles = 'bg-white border border-gray-200 rounded-2xl shadow-sm transition-all duration-200';
  const interactiveStyles = onClick ? 'cursor-pointer hover:shadow-lg hover:border-aqua-soft' : '';
  const selectedStyles = selected ? 'ring-2 ring-teal-deep bg-mint-light/30' : '';
  return <div className={`${baseStyles} ${interactiveStyles} ${selectedStyles} ${className}`} onClick={onClick} data-id="element-592">
      {children}
    </div>;
};